import React from 'react'

const EntityRecognizerViewResult = ({result}) => {
  const entityCategories = [
    'organizations',
    'people',
    'locations',
    'dates',
    'identifiers',
    'contact_info',
    'financial',
    'products',
    'documents',
    'events',
    'measurements',
    'statuses',
    'technical',
    'regulatory',
    'nutritional_info',
    'packaging',
    'product_attributes',
    'quality_parameters',
    'allergens'
  ];

  const formatEntityRow = (entity) => (
    <div className="mb-2 p-2 bg-base-200 rounded-lg">
      <div className="flex items-center justify-between">
        <span className="font-medium">{entity?.value}</span>
        <span className="px-2 py-0.5 rounded-full text-xs bg-success/20 text-success">
          {entity?.confidence * 100}%
        </span>
      </div>
      <div className="text-sm mt-1">
        <span className="text-base-content/70">Category: </span>
        <span className="capitalize">{entity.category}</span>
      </div>
      {entity?.mentions && entity?.mentions?.length > 0 && (
        <div className="text-sm mt-1">
          <span className="text-base-content/70">Mentions: </span>
          {entity?.mentions?.join(', ')}
        </div>
      )}
    </div>
  );

  return (
    <div className="mt-4 overflow-x-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Entity Categories */}
        <div className="space-y-4">
          {entityCategories?.map(category => {
            const entities = result?.entities?.[category] || [];
            if (entities.length === 0) return null;

            return (
              <div key={category} className="card bg-base-100 shadow-sm">
                <div className="card-body p-4">
                  <h3 className="card-title text-lg capitalize mb-2">{category.replace(/_/g, ' ')}</h3>
                  <div className="space-y-2">
                    {entities?.map((entity, index) => (
                      <div key={index}>
                        {formatEntityRow(entity)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Metadata Summary */}
        <div className="space-y-4">
          {result?.metadata && (
            <div className="card bg-base-100 shadow-sm">
              <div className="card-body p-4">
                <h3 className="card-title text-lg mb-2">Summary</h3>
                
                <div className="space-y-4">
                  {/* Entity Counts */}
                  <div>
                    <h4 className="font-medium mb-2">Entity Counts</h4>
                    <div className="text-sm">
                      <div className="flex justify-between mb-1">
                        <span>Total Entities:</span>
                        <span className="font-medium">{result?.metadata?.entity_counts?.total}</span>
                      </div>
                      {entityCategories.map(category => {
                        const count = result?.metadata?.entity_counts?.by_category?.[category];
                        if (count === undefined) return null;
                        return (
                          <div key={category} className="flex justify-between">
                            <span className="capitalize">{category.replace(/_/g, ' ')}:</span>
                            <span>{count}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Confidence Scores */}
                  <div>
                    <h4 className="font-medium mb-2">Confidence Scores</h4>
                    <div className="text-sm">
                      <div className="flex justify-between mb-1">
                        <span>Average:</span>
                        <span className="font-medium">{result?.metadata?.confidence_summary?.average * 100}%</span>
                      </div>
                      {entityCategories.map(category => {
                        const confidence = result?.metadata?.confidence_summary?.by_category?.[category];
                        if (confidence === undefined) return null;
                        return (
                          <div key={category} className="flex justify-between">
                            <span className="capitalize">{category.replace(/_/g, ' ')}:</span>
                            <span>{confidence * 100}%</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EntityRecognizerViewResult;